import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-[#1e3a5f] py-8 px-6" data-id="element-37">
        <div className="max-w-4xl mx-auto" data-id="element-38">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-39">
            <p className="text-white/60 text-sm" data-id="element-40">
              © {new Date().getFullYear()} Pantallas Bajo Control. Todos los
              derechos reservados.
            </p>

            <div className="flex items-center gap-6" data-id="element-41">
              <button onClick={() => setPrivacyOpen(true)} className="text-white/60 hover:text-white text-sm transition-colors underline-offset-4 hover:underline" data-id="element-42">
                Política de Privacidad
              </button>
              <button onClick={() => setTermsOpen(true)} className="text-white/60 hover:text-white text-sm transition-colors underline-offset-4 hover:underline" data-id="element-43">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-44">
        <div className="prose prose-sm max-w-none text-[#2d3748]" data-id="element-45">
          <p className="text-gray-500 text-sm mb-6" data-id="element-46">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-47">
            1. Información que Recopilamos
          </h3>
          <p className="mb-4" data-id="element-48">
            Recopilamos información que nos proporcionas directamente cuando
            realizas una compra, incluyendo tu nombre y dirección de correo
            electrónico para la entrega del producto digital.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-49">
            2. Uso de la Información
          </h3>
          <p className="mb-4" data-id="element-50">Utilizamos la información recopilada para:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-51">
            <li data-id="element-52">Procesar y entregar tu compra</li>
            <li data-id="element-53">Enviarte el ebook y materiales relacionados</li>
            <li data-id="element-54">Responder a tus consultas y solicitudes de soporte</li>
            <li data-id="element-55">Enviarte actualizaciones del producto (si aplica)</li>
          </ul>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-56">
            3. Protección de Datos
          </h3>
          <p className="mb-4" data-id="element-57">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            alteración, divulgación o destrucción.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-58">
            4. No Compartimos tu Información
          </h3>
          <p className="mb-4" data-id="element-59">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros. Esto no incluye terceros de confianza que nos ayudan a
            operar nuestro sitio web o procesar pagos, siempre que esas partes
            acuerden mantener esta información confidencial.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-60">
            5. Cookies
          </h3>
          <p className="mb-4" data-id="element-61">
            Nuestro sitio puede utilizar cookies para mejorar tu experiencia.
            Puedes configurar tu navegador para rechazar cookies, aunque esto
            puede afectar algunas funcionalidades.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-62">
            6. Tus Derechos
          </h3>
          <p className="mb-4" data-id="element-63">
            Tienes derecho a acceder, rectificar o eliminar tus datos
            personales. Para ejercer estos derechos, puedes contactarnos a
            través de los canales disponibles.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-64">
            7. Cambios a esta Política
          </h3>
          <p className="mb-4" data-id="element-65">
            Nos reservamos el derecho de actualizar esta política de privacidad
            en cualquier momento. Te notificaremos de cualquier cambio
            publicando la nueva política en esta página.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-66">
        <div className="prose prose-sm max-w-none text-[#2d3748]" data-id="element-67">
          <p className="text-gray-500 text-sm mb-6" data-id="element-68">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-69">
            1. Aceptación de los Términos
          </h3>
          <p className="mb-4" data-id="element-70">
            Al acceder y utilizar este sitio web y realizar una compra, aceptas
            estar sujeto a estos términos y condiciones de uso.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-71">
            2. Producto Digital
          </h3>
          <p className="mb-4" data-id="element-72">
            "Pantallas Bajo Control" es un producto digital (ebook) que se
            entrega electrónicamente. Una vez completada la compra, recibirás
            acceso inmediato al material a través del correo electrónico
            proporcionado.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-73">
            3. Licencia de Uso
          </h3>
          <p className="mb-4" data-id="element-74">
            Al comprar el ebook, obtienes una licencia personal e intransferible
            para usar el contenido. No está permitido:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-75">
            <li data-id="element-76">Redistribuir, revender o compartir el contenido</li>
            <li data-id="element-77">Modificar o crear obras derivadas</li>
            <li data-id="element-78">Usar el contenido con fines comerciales sin autorización</li>
          </ul>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-79">
            4. Política de Reembolso
          </h3>
          <p className="mb-4" data-id="element-80">
            Ofrecemos una garantía de satisfacción de 7 días. Si no estás
            satisfecho con el producto, puedes solicitar un reembolso completo
            dentro de los 7 días posteriores a la compra, sin preguntas.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-81">
            5. Descargo de Responsabilidad
          </h3>
          <p className="mb-4" data-id="element-82">
            El contenido de este ebook es solo para fines informativos y
            educativos. Los resultados pueden variar según cada familia y
            situación. No garantizamos resultados específicos, ya que el éxito
            depende de la aplicación consistente del programa.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-83">
            6. Propiedad Intelectual
          </h3>
          <p className="mb-4" data-id="element-84">
            Todo el contenido, incluyendo textos, gráficos, logos y materiales
            descargables, está protegido por derechos de autor y es propiedad
            exclusiva de Pantallas Bajo Control.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-85">
            7. Limitación de Responsabilidad
          </h3>
          <p className="mb-4" data-id="element-86">
            En ningún caso seremos responsables por daños indirectos,
            incidentales, especiales o consecuentes que resulten del uso o la
            imposibilidad de usar el producto.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-87">
            8. Modificaciones
          </h3>
          <p className="mb-4" data-id="element-88">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación en el sitio web.
          </p>

          <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-89">
            9. Ley Aplicable
          </h3>
          <p className="mb-4" data-id="element-90">
            Estos términos se regirán e interpretarán de acuerdo con las leyes
            aplicables, sin tener en cuenta sus disposiciones sobre conflictos
            de leyes.
          </p>
        </div>
      </Modal>
    </>;
}